import React, { useState } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { FiArrowUpRight } from "react-icons/fi";
import { socialLoginUrl, socialPlatformLabel } from "../constants/socialPlatforms";
import "../assets/css/SocialPasswordReveal.css";
import "../pages/dm/dm.css";

/**
 * Opens the platform's login page in a new tab. Where the page supports it (Facebook, Google) the username
 * is pre-filled; it is also copied to the clipboard so it can be pasted on any platform. Passwords are never
 * passed along: they are copied from the reveal next to it. ``compact`` shows a small "Open" chip for tables.
 */
export default function SocialSignInButton({ platform, username, compact = false }) {
  const [copied, setCopied] = useState(false);
  const login = String(username || "").trim();
  const href = socialLoginUrl(platform, login);
  if (!href) return null;

  const label = socialPlatformLabel(platform);
  const title = login
    ? `Opens the ${label} login page with username "${login}" (also copied)`
    : `Opens the ${label} login page`;

  const copyUsername = async (e) => {
    e.stopPropagation();
    if (!login) return;
    try {
      await navigator.clipboard.writeText(login);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (_) {
      /* clipboard blocked */
    }
  };

  if (compact) {
    return (
      <a
        className="dms-open dms-open--chip"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={copyUsername}
        title={copied ? "Username copied" : title}
        aria-label={title}
      >
        Open <FiArrowUpRight aria-hidden="true" />
      </a>
    );
  }

  return (
    <span className="spr">
      <a
        className="spr__btn spr__btn--primary"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={copyUsername}
        title={title}
      >
        <FaExternalLinkAlt aria-hidden="true" /> Sign in to {label}
      </a>
      {copied ? <span className="spr__note">Username copied</span> : null}
    </span>
  );
}
